module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_2-fe4de3c8d817f81155ecf5eb1f3cc705.jpg";